import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";
import transactionHelper from "../transaction/transactionHelper";

export default {
  DoEditRemarkByTransaction(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        remark: input.remark,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/EditRemarkByTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditReferenceNameByTransaction(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        referenceName: input.referenceName,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/EditReferenceNameByTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditDueDateByTransaction(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        dueDate: input.dueDate,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/EditDueDateByTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  //#region EditTransactionDate
  DoEditQuotationDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/EasyEditQuotationDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditInvoiceDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/EasyEditInvoiceDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditReceiptDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/EasyEditReceiptDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditCreditNoteDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/creditNote/EasyEditCreditNoteDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditDebitNoteDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/debitNote/EasyEditDebitNoteDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditBillingNoteDate(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        date: input.date,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/EasyEditBillingNoteDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  //#endregion

  //#region EditTransactionContact
  DoEditQuotationContact(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        contactId: input.contactId,
        isValidateCreditLimit: input.isValidateCreditLimit,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/EasyEditQuotationContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditInvoiceContact(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        contactId: input.contactId,
        isValidateCreditLimit: input.isValidateCreditLimit,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/EasyEditInvoiceContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditReceiptContact(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        contactId: input.contactId,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/EasyEditReceiptContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditCreditNoteContact(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        contactId: input.contactId,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/creditNote/EasyEditCreditNoteContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditDebitNoteContact(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        contactId: input.contactId,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/debitNote/EasyEditDebitNoteContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  //#endregion

  //#region EditTransactionNumber
  DoEditQuotationNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/EasyEditQuotationNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditInvoiceNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/EasyEditInvoiceNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditReceiptNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/EasyEditReceiptNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditCreditNoteNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/creditNote/EasyEditCreditNoteNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditDebitNoteNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/debitNote/EasyEditDebitNoteNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditBillingNoteNumber(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        transactionNumber: input.transactionNumber,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/billingNote/EasyEditBillingNoteNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  //#endregion

  //#region EditProductAccountDescription
  DoEasyEditProductAccountDescriptionQuotation(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/EasyEditProductAccountDescriptionQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEasyEditProductAccountDescriptionInvoice(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/EasyEditProductAccountDescriptionInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEasyEditProductAccountDescriptionReceipt(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/EasyEditProductAccountDescriptionReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEasyEditProductAccountDescriptionCreditNote(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/EasyEditProductAccountDescriptionCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEasyEditProductAccountDescriptionDebitNote(input) {
    let _input = {
      data: {
        transactionId: input.transactionId,
        productAccountCodeAndDesciptionList: input.productAccountCodeAndDesciptions,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/EasyEditProductAccountDescriptionDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  //#endregion
  DoEasyEditPayment(input) {
    let _input = {
      data: {
        paymentGroupId: input.paymentGroupId,
        paymentTransactionList: input.editPaymentTransaction,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/EasyEditPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEasyEditPaymentDate(input) {
    let _input = {
      data: {
        paymentGroupId: input.paymentGroupId,
        paymentGroupDate: input.paymentDate,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/EasyEditPaymentDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditQuotationWhtTransactionItem(input) {
    let summaryAndCurrency = transactionHelper.ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      data: {
        transactionId: input.transactionId,
        productWhtList: input.productWhtList,
        transactionSummary: summaryAndCurrency.transactionSummary,
        transactionCurrency: summaryAndCurrency.transactionCurrency,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/EditQuotationWhtTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditInvoiceWhtTransactionItem(input) {
    let summaryAndCurrency = transactionHelper.ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      data: {
        transactionId: input.transactionId,
        productWhtList: input.productWhtList,
        transactionSummary: summaryAndCurrency.transactionSummary,
        transactionCurrency: summaryAndCurrency.transactionCurrency,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/EditInvoiceWhtTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditReceiptWhtTransactionItem(input) {
    let summaryAndCurrency = transactionHelper.ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      data: {
        transactionId: input.transactionId,
        productWhtList: input.productWhtList,
        transactionSummary: summaryAndCurrency.transactionSummary,
        transactionCurrency: summaryAndCurrency.transactionCurrency,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/EditReceiptWhtTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditCreditNoteWhtTransactionItem(input) {
    let summaryAndCurrency = transactionHelper.ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      data: {
        transactionId: input.transactionId,
        productWhtList: input.productWhtList,
        transactionSummary: summaryAndCurrency.transactionSummary,
        transactionCurrency: summaryAndCurrency.transactionCurrency,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/EditCreditNoteWhtTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoEditDebitNoteWhtTransactionItem(input) {
    let summaryAndCurrency = transactionHelper.ConvertToSummaryAndCurrency(input.transaction);
    let _input = {
      data: {
        transactionId: input.transactionId,
        productWhtList: input.productWhtList,
        transactionSummary: summaryAndCurrency.transactionSummary,
        transactionCurrency: summaryAndCurrency.transactionCurrency,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/EditDebitNoteWhtTransactionItem", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
};
